<template>
    <v-content>
        <v-container fluid>
            <v-row >
                <v-col cols="12" sm="12">
                    <router-view></router-view>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>
    export default {
    }
</script>